// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2WMZe","loaderOuter":"PageOverlayLoader_loaderOuter__1EYw3"};